import { getOnboardingV1 } from '@/onboarding-homepage/api/onboarding-api';

export async function fetchHasOnboardingAccess () {
    const response = await getOnboardingV1();

    return response?.data?.isComplete === false;
}
